// extracted by mini-css-extract-plugin
export default {"staticMap":"StaticMap-module__staticMap___2btCT"};